<template>  
	<div class="row">
		<div class="documentation">
			<div class="documentation-container">
				
				<div id="response_errors" class="response_errors_container" style="display:none"></div>
				
				<div>
					
					<nav aria-label="breadcrumb" class="d-none d-xl-block">
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/docs">Документы</a></li>
							<li class="breadcrumb-item"><a href="/docs-edit">Список документов</a></li>
							<li v-if="type == 'create'" class="breadcrumb-item active" aria-current="page">Добавить новый релиз</li>
							<li v-if="type == 'update'" class="breadcrumb-item active" aria-current="page">Редактировать релиз</li>
						</ol>
					</nav>
					<div class="title-block">
						<div class="title-block__left">
							<div v-if="type == 'create'" class="title-block__title">
								Добавить новый релиз
							</div>
							<div v-if="type == 'update'" class="title-block__title">
								Редактировать релиз
							</div>
						</div>
					</div>
					
					<input type="hidden" id="releaseIdInput" v-model="releaseId">
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Номер релиза *</div>
							<input type="text" class="form-control" id="releaseNumberInput" placeholder="введите номер" v-model="releaseNumber">
						</div>
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Название релиза *</div>
							<input type="text" class="form-control" id="releaseNameInput" placeholder="введите название" v-model="releaseName">
						</div>
					</div>
										
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Описание релиза</div>
							<textarea name="" id="releaseDescriptionInput" cols="30" rows="3" class="form-control" placeholder="введите описание" v-model="releaseDescription"></textarea>
						</div>
					</div>
					
					<input type="hidden" id="releaseClientInput" v-model="releaseClientSelected">
					<div class="row mb-4">
						<div class="col-12">	
							<div class="form-label">Выберите клиента *</div>
							<v-select class="searchable" v-model="releaseClient" 
								:options="clientOptions"
								@option:selected="onReleaseClientChange($event)"
								:deselectFromDropdown="false"
								:clearable="false">
								<template #no-options="{ search, searching, loading }">
									<div class="text-not-found">Не найдено</div>
								</template>
							</v-select>
						</div>	
					</div>
					
					<input type="hidden" id="releaseSoftwareInput" v-model="releaseSoftwareSelected">
					<div class="row mb-4">
						<div class="col-12">	
							<div class="form-label">Выберите программу *</div>
							<v-select class="searchable" v-model="releaseSoftware"
								:options="softwareOptions"
								@option:selected="onReleaseSoftwareChange($event)"
								:deselectFromDropdown="false"
								:clearable="false">
								<template #no-options="{ search, searching, loading }">
									<div class="text-not-found">Не найдено</div>
								</template>
							</v-select>
						</div>	
					</div>
					
					<input type="hidden" id="releaseVersionInput" v-model="releaseVersionSelected">
					<div class="row mb-4">
						<div class="col-12">	
							<div class="form-label">Выберите версию *</div>
							<v-select class="searchable" v-model="releaseVersion"
								:options="versionOptions"
								@option:selected="onReleaseVersionChange($event)"
								:deselectFromDropdown="false"
								:clearable="false">
								<template #no-options="{ search, searching, loading }">
									<div class="text-not-found">Не найдено</div>
								</template>
							</v-select>
						</div>	
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Дата релиза</div>
							<input type="date" class="form-control" id="releaseReleaseDateInput" placeholder="Placeholder" v-model="releaseReleaseDate">
						</div>
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Дата начала показа *</div>
							<input type="date" class="form-control" id="releaseStartDateInput" placeholder="Placeholder" v-model="releaseStartDate">
						</div>
					</div>					
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-check">
								<input class="form-check-input" type="checkbox" value="" id="releaseVisibleInput" v-model="releaseVisible">
								<label class="form-check-label" for="releaseVisibleInput"> Опубликован</label>
							</div>
						</div>
					</div>
					
					<div class="d-flex flex-column flex-lg-row justify-content-between">
						<button class="btn mb-2 mb-lg-0 me-lg-auto" @click.prevent="saveRelease">
							<span>Сохранить</span>
						</button>
						<button class="btn btn-lg btn-outline-dark" @click.prevent="cancel">
							<span>Отменить</span>
						</button>
					</div>
					
				</div>
				

			</div>
		</div>	
    </div>	
</template>

<script>

export default {
    name: "CreateReleaseDocumentationComponent",
	props: [
        'type',
        'element',
        'elementdetail',
		'clientlist',
		'softwarelist',
		'versionlist',
    ],
    
    data: () => {
        return {
            clientOptions: [],
            softwareOptions: [],
            versionOptions: [],
            releaseClient: {label: ''},
            releaseSoftware: {label: ''},
            releaseVersion: {label: ''},
            releaseId: '',
            releaseName: '',
            releaseNumber: '',
            releaseDescription: '',
            releaseClientSelected: '',
            releaseSoftwareSelected: '',
            releaseVersionSelected: '',
            releaseSupportEndDate: '',
            releaseStartDate: '',
            releaseReleaseDate: '',
            releaseVisible: true,
        };
    },
	created() {

		if(this.clientlist.length > 0) {
			var list = [];
			this.clientlist.forEach(obj => {
				list.push({
					value: obj.id,
					label: obj.name,
				});
			});
			this.clientOptions = list;
		};
		
		if(this.softwarelist.length > 0) {
			var list = [];
			this.softwarelist.forEach(obj => {
				if(this.elementdetail.client_id) {
					if(obj.client == this.elementdetail.client_id) {	
						list.push({
							value: obj.id,
							label: obj.name
						});
					}
				} else {
					list.push({
						value: obj.id,
						label: obj.name
					});
				}
			});
			this.softwareOptions = list;
		};
		
		if(this.versionlist.length > 0) {
			var list = [];
			this.versionlist.forEach(obj => {
				if(this.elementdetail.sw_id) {
					if(obj.sw_id == this.elementdetail.sw_id) {	
						list.push({
							value: obj.id,
							label: obj.name
						});
					}
				} else {
					list.push({
						value: obj.id,
						label: obj.name
					});
				}
			});
			this.versionOptions = list;
		};
    },
    methods: {
        
		itemGet: async function () {
            this.releaseId = this.elementdetail.id;
            this.releaseName = this.elementdetail.name;
            this.releaseNumber = this.elementdetail.number;
            this.releaseDescription = this.elementdetail.description;
			this.releaseClient = {value: this.elementdetail.client_id, label: this.elementdetail.client_name};
			this.releaseClientSelected = this.elementdetail.client_id;
			this.releaseSoftware = {value: this.elementdetail.sw_id, label: this.elementdetail.sw_name};
			this.releaseSoftwareSelected = this.elementdetail.sw_id;
			this.releaseVersion = {value: this.elementdetail.vers_id, label: this.elementdetail.vers_name};
			this.releaseVersionSelected = this.elementdetail.vers_id;
			if(this.elementdetail.release_date) {
				var releaseDate = this.elementdetail.release_date.split(' ');
				this.releaseReleaseDate = releaseDate[0];
			}
			if(this.elementdetail.start_date) {
				var startDate = this.elementdetail.start_date.split(' ');
				this.releaseStartDate = startDate[0];
			}
			this.releaseVisible = (this.elementdetail.visible == 0) ? false : true;
        },

		cancel: function () {
			document.location = '/docs-edit';
		},
		
		saveRelease: function () {
			var releaseData = {
				type: this.type,
				version: document.getElementById('releaseVersionInput').value,
				number: document.getElementById('releaseNumberInput').value,
				name: document.getElementById('releaseNameInput').value,
				description: document.getElementById('releaseDescriptionInput').value,
				release_date: document.getElementById('releaseReleaseDateInput').value,
				start_date: document.getElementById('releaseStartDateInput').value,
				visible: document.getElementById('releaseVisibleInput').checked ? 1 : 0,
			};
			if(this.type == 'update') {
				releaseData.id = document.getElementById('releaseIdInput').value;
			}
			axios.post('/docs-edit/release', releaseData)
				.then(res => {
					if(res.data.status == 'error') {
						var error_list = '<h5>При добавлении версии произошли следующие ошибки:</h5><ul>';
						res.data.errors.forEach(error => {
							error_list += '<li>' + error + '</li>'
						});
						error_list += '</ul>';
						document.getElementById('response_errors').innerHTML = error_list;
						document.getElementById('response_errors').style.display = 'block';
						document.getElementById('response_errors').scrollIntoView({behavior: "smooth"});
					} else if(res.data.status == 'ok') {
						document.location = '/docs-edit';
					}
				});
		},
		
		onReleaseClientChange(events) {
			this.releaseClientSelected = events.value;
			this.buildSoftwareOption();
			this.releaseSoftwareSelected = '';
			this.releaseVersionSelected = '';
		},
		
		onReleaseSoftwareChange(events) {
			this.releaseSoftwareSelected = events.value;
			this.buildVersionOption();
			this.releaseVersionSelected = '';
		},
		
		onReleaseVersionChange(events) {
			this.releaseVersionSelected = events.value;
		},

		buildSoftwareOption: function () {
			var client = this.releaseClientSelected;
			if(this.softwarelist.length > 0) {
				var list = [];
				this.softwarelist.forEach(obj => {
					if(obj.client == client) {	
						list.push({
							value: obj.id,
							label: obj.name
						});
					}	
				});
				this.softwareOptions = list;
				this.releaseSoftware = {label: ''};
				this.releaseVersion = {label: ''};
			}
		},
		
		buildVersionOption: function () {
			var software = this.releaseSoftwareSelected;
			if(this.versionlist.length > 0) {
				var list = [];
				this.versionlist.forEach(obj => {
					if(obj.sw_id == software) {	
						list.push({
							value: obj.id,
							label: obj.name
						});
					}	
				});
				this.versionOptions = list;
				this.releaseVersion = {label: ''};
			}
		},
		
    },
    mounted() {
		this.itemGet();
    },
};
</script>
